var AllowedExtraInfosFields;
(function (AllowedExtraInfosFields) {
    // Apollo Client properties
    AllowedExtraInfosFields["timeElapsed"] = "timeElapsed";
    AllowedExtraInfosFields["operationType"] = "operationType";
    AllowedExtraInfosFields["operationName"] = "operationName";
    // Apollo Server properties
    AllowedExtraInfosFields["operationOwner"] = "operationOwner";
    // Cloud Logger properties
    AllowedExtraInfosFields["clientIP"] = "clientIP";
    AllowedExtraInfosFields["details"] = "details";
    AllowedExtraInfosFields["request"] = "request";
    AllowedExtraInfosFields["response"] = "response";
    // Flag to identify if the request is coming from the Samples MFE or legacy FE
    AllowedExtraInfosFields["isSamplesMfe"] = "isSamplesMfe";
})(AllowedExtraInfosFields || (AllowedExtraInfosFields = {}));

export { AllowedExtraInfosFields };
